<template>
  <div class="componentRoot">
    <ButtonRowVue>
      <template v-slot:leftSide>
        <v-col :cols="searchBarCols" class="pr-2">
          <SearchBarVue :labelArray="['basics.name', 'basics.number']" @search="updateSearchQueue" />
        </v-col>
      </template>
      <v-col cols="auto" v-if="$checkRouterPermission('POST')">
        <v-tooltip :text="$t('basics.new', { type: $t('basics.service') })">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" @click="showEditService($event)" class="primaryButton squareButton" flat><v-icon
                size="x-large">mdi-plus</v-icon></v-btn>
          </template>
        </v-tooltip>
      </v-col>
    </ButtonRowVue>

    <TableVue :numPages="numPages" @switchPage="switchPage" id="serviceTable" :resetPage="resetPage"
      :total="totalCount">
      <thead>
        <tr>
          <th class="text-left" @click="switchSortBy('number')" :style="{
            color: sortBy == 'number' ? 'rgb(var(--v-theme-primary))' : 'unset',
          }">
            <div style="display: flex; align-items: center">
              <b style="font-size: medium">{{ $t("basics.number") }}</b>
              <div v-if="sortBy == 'number'">
                <v-icon v-if="!sortDirection">mdi-menu-up</v-icon>
                <v-icon v-else>mdi-menu-down</v-icon>
              </div>
              <div v-else>
                <v-icon>mdi-menu-right</v-icon>
              </div>
            </div>
          </th>

          <th class="text-left">
            <div style="display: flex; align-items: center">
              <b style="font-size: medium">{{ $t("basics.name") }}</b>
            </div>
          </th>

          <th class="text-left">
            <div style="display: flex; align-items: center">
              <b style="font-size: medium">{{ $t("basics.unit") }}</b>
            </div>
          </th>

          <th class="text-left">
            <div style="display: flex; align-items: center">
              <b style="font-size: medium">{{ $t("basics.price") }}</b>
            </div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody @click="showEditService($event, d)" v-for="(d, dIndex) in service" :key="d.id">
        <tr v-if="dIndex == 0 || d.category.id != service[dIndex - 1].category.id" class="removeBorderBottom">
          <td colspan="100" style="height: 40px !important;">
            <i><b>{{ d.category.number }}</b> {{ d.category.name }}</i>
          </td>
        </tr>
        <tr :class="{ removeBorderBottom: d.comment }">
          <td style="width: 100px;">
            <div style="display: flex; align-items: center;">
              <v-tooltip v-if="d.default_bill" :text="$t('messages.defaultBillService')">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" class="mr-2" color="primary">mdi-star</v-icon>
                </template>
              </v-tooltip>
              <v-tooltip v-if="d.marked" :text="$t('messages.markedService')">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" class="mr-2" color="primary">mdi-flag</v-icon>
                </template>
              </v-tooltip>

              {{ d.number }}
            </div>
          </td>
          <td style="max-width: 30vw;">
            {{ d.name }}
          </td>
          <td style="max-width: 150px;">
            {{ $t("constants.bill_unit_" + d.display_unit) }}
          </td>
          <td>
            <span>
              {{ d.price_bill }}€
            </span>
            <br>
            <small>(<span v-if="d.price_min && d.price_max">
              {{ d.price_min }}€ {{ $t("basics.to") }}
              {{ d.price_max }}€
            </span>
            <span v-else-if="d.price_min">
              {{ d.price_min }}€
            </span>
            <span v-else-if="d.price_max">
              {{ $t("basics.to") }} {{ d.price_max }}€
            </span>)</small>
          </td>
          <td class="text-right">
            <v-tooltip :text="$t('basics.duplicate', { type: $t('basics.service') })">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" @click="duplicateService(service)"> mdi-content-copy </v-icon>
              </template>
            </v-tooltip>

            <v-tooltip :text="$t('basics.edit', { type: $t('basics.service') })">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props"> mdi-pencil </v-icon>
              </template>
            </v-tooltip>
          </td>
        </tr>
        <tr v-if="d.comment">
          <td colspan="100" style="height: 40px !important;">
            <i>
              <p style="opacity: 0.65; padding-left: 104px">{{ d.comment }}</p>
            </i>
          </td>
        </tr>
      </tbody>

      <tbody v-if="!service || service.length == 0">
        <tr>
          <td colspan="400">
            <i>{{ $t("messages.noItems") }}</i>
          </td>
        </tr>
      </tbody>
    </TableVue>

    <ServiceEditVue :duplicate="duplicate" :refreshDisplay="editServiceDrawer" @close="closeEditService" :serviceData="activeService"
      @delete="showDeleteService" :readonly="!$checkRouterPermission('POST') && !$checkRouterPermission('PATCH')" />

    <DeletionWarningVue :type="'service'" :additionalMessage="$t('messages.confirmDeletionItem', { item: activeService?.name })
      " :refreshDisplay="deleteServiceDrawer" @delete="deleteService" style="z-index: 1007 !important" />

    <LoadingScreenVue :loading="loading" />
  </div>
</template>

<script>
import ServiceEditVue from "../../../components/settings/ServiceEdit.vue";

export default {
  name: "serviceList",

  data() {
    return {
      service: undefined,

      activeService: undefined,
      editServiceDrawer: 0,
      deleteServiceDrawer: 0,

      currPage: 1,
      numPages: undefined,
      totalCount: undefined,
      resetPage: 0,


      searchQueue: undefined,
      searchParams: undefined,

      filterParams: undefined,

      sortBy: "number",
      sortDirection: true,

      loading: false,

      duplicate: false,
    };
  },

  computed: {
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
    searchBarCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 9;
        case "sm":
          return 9;
        case "md":
          return 6;
        case "lg":
          return 4;
        case "xl":
          return 4;
        case "xxl":
          return 3;
        default:
          return 4;
      }
    },
  },

  components: {
    ServiceEditVue,
  },

  methods: {
    duplicateService(service){
      this.duplicate = true
      this.activeService = service
      this.editServiceDrawer++
    },
    getIcon(service) {
      switch (service.display_type) {
        case "hotel":
          return "mdi-bunk-bed";
        case "campus":
          return "mdi-table-chair";
        case "gym":
          return "mdi-garage-open-variant";
        case "multiUse":
          return "mdi-dots-horizontal-circle-outline";
        case "external":
          return "mdi-open-in-new";
        default:
          return "mdi-table-chair";
      }
    },
    fetchData() {
      this.setLoading(true);

      let searchParams =
        "?page=" +
        this.currPage +
        "&order=" +
        this.sortBy +
        "&direction=" +
        (this.sortDirection ? "up" : "down");

      if (this.searchParams) {
        searchParams += this.searchParams;
      }

      if (this.searchQueue) {
        searchParams += "&query=" + this.searchQueue;
      }

      if (this.filterParams) {
        searchParams += this.filterParams;
      }

      this.axios
        .get(this.axios.defaults.baseURL + "media/services/" + searchParams)
        .then((resp) => {
          this.setLoading(false);
          this.service = resp.data.results;
          this.totalCount = resp.data.count;

          if (resp.data.results.length == 0) {
            this.numPages = 0;
          } else if (this.currPage == 1) {
            this.numPages = Math.ceil(resp.data.count / resp.data.results.length);
          }
        })
        .catch((e) => {
          this.setLoading(false);
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    setLoading(value) {
      this.loading = value;
    },
    showEditService(event, service) {
      event.preventDefault();
      event.stopPropagation();

      this.duplicate = false
      this.activeService = service;
      this.editServiceDrawer++;
    },
    closeEditService(value) {
      this.duplicate = false
      this.activeService = undefined;
      this.editServiceDrawer = 0;

      this.setLoading(false);

      if (value) {
        this.fetchData();
      }
    },
    switchPage(data) {
      this.currPage = data;

      this.fetchData();
    },
    getReadableDatetime(datetime) {
      if (datetime) return this.$moment(datetime).format("DD.MM.YYYY HH:mm");
      else return undefined;
    },
    updateSearchQueue(value) {
      this.resetPage++;
      this.currPage = 1;
      this.searchQueue = value;

      this.fetchData();
    },
    switchSortBy(val) {
      if (this.sortBy != val) {
        this.sortBy = val;
        this.sortDirection = true;
      } else {
        this.sortDirection = !this.sortDirection;
      }

      this.currPage = 1;
      this.resetPage++;

      this.fetchData();
    },
    applyFilter(query) {
      this.resetPage++;
      this.filterParams = query;
      this.fetchData();
    },
    showDeleteService(service) {
      this.activeService = service;
      this.deleteServiceDrawer++;
    },
    deleteService() {
      this.setLoading(true);
      this.axios
        .patch(
          this.axios.defaults.baseURL +
          "ressource/service/delete/" +
          this.activeService.id,
          {
            deleted: true,
          }
        )
        .then(() => {
          this.setLoading(false);
          this.deleteServiceDrawer = 0;
          this.editServiceDrawer = 0;
          this.fetchData();
        })
        .catch((e) => {
          this.setLoading(false);
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
